"use client";

import React, { useState, useEffect } from "react";
import parser from "html-react-parser";
import CardItem from "./CardsItem";
import VimeoPlayer from "./VimeoPlayer";
import buttonHelper from "./../helpers/buttonHelper";
import stringHelpers from "../helpers/stringHelpers";

const AccordionItemFilter = ({
  activated,
  activeFacet,
  buttonPage,
  buttonText,
  buttonUrl,
  cardItem,
  handleFilter,
  // handleSlide,
  id,
  itemId,
  items,
  menu,
  slideEffect = false,
  subtitle,
  targetBlank,
  text,
  title,
  videoUrl,
  videoUrl2,
}) => {
  const [activeIndex, setActiveIndex] = useState(null); // Store index of open accordion
  const [preActivatedItem, setPreActivatedItem] = useState(activated);
  const handleSlide = (index, e) => {
    e.preventDefault();
    const setActiveIndexFunction = (e, index) => {
      if (e.target.parentElement.className.includes("is-active")) {
        return null;
      } else {
        return index;
      }
    };

    setActiveIndex(setActiveIndexFunction(e, index)); // Toggle clicked accordion

    // Jquery Code for slideEffect
    if (slideEffect) {
      if ($(e.target.parentElement).hasClass("is-active")) {
        $(e.target.nextElementSibling).slideUp();
      } else {
        $(e.target.nextElementSibling).slideDown();
      }
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined" && window.document !== undefined) {
      const hash = window.location.hash?.substring(1);
      const elementSelector = document.querySelector(`a[name="${hash}"]`);
      const element = hash.length > 0 ? elementSelector : null;

      const handleClickOutside = (event) => {
        if (element && !element.contains(event.target)) {
          element.style.outline = "inherit";
          element.style.borderRadius = "none";
        }
      };
      // Function to extract the hash and find the corresponding element
      const getElementIdFromHash = () => {
        if (element) {
          setActiveIndex(element.id);
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });

          element.style.outline = "2px solid #000"; // Add focus outline
          element.style.borderRadius = "2px"; // Add focus outline
        }
      };

      // Run on initial render
      getElementIdFromHash();
      // Listener for hash changes (if the hash might change)
      document.addEventListener("hashchange", getElementIdFromHash);
      document.addEventListener("mousedown", handleClickOutside);

      // Clean up the event listener
      return () => {
        document.removeEventListener("hashchange", getElementIdFromHash);
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, []); // Empty dependency array to ensure it runs once on mount

  const buttonPageUrl = !!buttonPage
    ? buttonHelper.findSlugPath(menu, buttonPage.data?.attributes?.title)
    : null;

  const getDisplayStyle = (slideEffect, activeIndex, id, preActivatedItem) => {
    if (!slideEffect && activeIndex === id && !!preActivatedItem) {
      return "none";
    }

    if (!slideEffect && (activeIndex === id || !!preActivatedItem)) {
      return "block";
    }

    if (slideEffect && activeIndex === null && preActivatedItem === undefined) {
      return "none";
    }

    if (slideEffect && activeIndex !== null && preActivatedItem === undefined) {
      return "none";
    }

    if (
      !slideEffect &&
      activeIndex === null &&
      preActivatedItem === undefined
    ) {
      return "none";
    }

    if (activeIndex == id || !!preActivatedItem) {
      return "block";
    }

    return "none";
  };

  return (
    <li
      className={`accordion-item tps-accordion-item ${
        activeIndex == id && !!preActivatedItem
          ? ""
          : activeIndex == id || !!preActivatedItem
            ? "is-active"
            : ""
      }`}
      data-accordion-item=""
      role="presentation"
    >
      <a
        href={`${title ? `#${title.split(" ").join("")}-${id}` : "#"}`}
        name={`${title ? `${title.split(" ").join("")}-${id}` : ""}`}
        onClick={(e) => handleSlide(id, e)}
        className="accordion-title"
        aria-controls={`${title}-${id}`}
        role="tab"
        id={id}
        aria-expanded={
          activeIndex == id && !!preActivatedItem
            ? "false"
            : activeIndex == id || !!preActivatedItem
              ? "true"
              : "false"
        }
        aria-selected={
          activeIndex == id && !!preActivatedItem
            ? "false"
            : activeIndex == id || !!preActivatedItem
              ? "true"
              : "false"
        }
      >
        {title && title}
      </a>
      <div
        className="accordion-content"
        data-tab-content=""
        id={`${title}-${id}`}
        role="tabPanel"
        aria-labelledby={`${title}-${id}-label`}
        aria-hidden={
          activeIndex === id && preActivatedItem
            ? "true"
            : activeIndex === id || preActivatedItem
              ? "false"
              : "true"
        }
        style={{
          display: getDisplayStyle(
            slideEffect,
            activeIndex,
            id,
            preActivatedItem
          ),
        }}
      >
        <div className="accordion-content-inner">
          {items &&
            items.length > 0 &&
            items.map((item, index) => {
              return (
                <div
                  key={index}
                  className="facet-item"
                  onClick={() => {
                    handleFilter(itemId, item.item_name);
                  }}
                >
                  <a
                    href="#"
                    className={`facet search-filter-options ${
                      activeFacet && activeFacet.includes(item.item_name)
                        ? "active-facet"
                        : ""
                    }`}
                  >
                    {item.item_name}
                    {!!item.numberOfUsing && (
                      <span className="facet-count">
                        ({item.numberOfUsing})
                      </span>
                    )}
                  </a>
                </div>
              );
            })}
          {subtitle && subtitle}
          {text && parser(stringHelpers.imagePathReplace(text))}
          {cardItem && (
            <div
              className="tps-card-listing tps-related-pages-cards tps-related-pages grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-4 align-"
              style={{ width: "auto" }}
            >
              <CardItem
                buttonPage={cardItem.buttonPage}
                buttonPage2={cardItem.buttonPage2}
                buttonText={cardItem.buttonText}
                buttonText2={cardItem.buttonText2}
                date={cardItem.date}
                image={cardItem.image?.data?.attributes}
                menu={menu}
                fromPage={
                  cardItem?.page?.data?.attributes ||
                  cardItem?.news?.data?.attributes ||
                  cardItem?.course?.data?.attributes ||
                  cardItem?.concert?.data?.attributes
                }
                page={cardItem?.page}
                news={cardItem?.news}
                course={cardItem?.course}
                concert={cardItem?.concert}
                shortText={cardItem.shortText}
                title={cardItem.title}
                url={cardItem.url}
              />
            </div>
          )}
          {videoUrl && <VimeoPlayer videoUrl={videoUrl} />}
          {videoUrl2 && <VimeoPlayer videoUrl={videoUrl2} />}
          {buttonText && (
            <a
              href={buttonUrl || buttonPageUrl || "#"}
              target={`${!!targetBlank ? "_blank" : "_self"}`}
              className="button"
            >
              {buttonText && buttonText}
            </a>
          )}
        </div>
      </div>
      {/* )} */}
    </li>
  );
};

export default AccordionItemFilter;
